import React from 'react'

const NameField = (props) => {
    const {lesson, ...otherProps} = props
    return (
        <span {...otherProps}>{lesson?.title}</span>
    )
}

export default NameField;